import styled from "@emotion/styled";
import { useFormData } from "../../../contexts/FormData";
import { useFormikContext } from "formik";

import { useQuery } from "@tanstack/react-query";

import { getInventoryValues } from "../../InventoryValues/apiService";

import { Grid } from "@mui/material";

import Field from "../../../utils/FormikFields/Field";

import { InputLabel } from "../../../utils/Common";

import AutoCompleteSolo from "../../../utils/FormikFields/AutoCompleteSolo";
import AutoCompleteSoloMulti from "../../../utils/FormikFields/AutoCompleteSoloMulti";

const getOptions = (values) => {
  return values?.map((el) => ({
    label: el.value,
    value: el.value,
  }));
}

const PriceInfo = () => {
  const { values } = useFormikContext() || {};

  const { data: inventory_values } = useQuery({
    queryKey: ['inventory_values', values?.brand_name],
    queryFn: () => getInventoryValues(values?.brand_name),
    enabled: !!values?.brand_name,
    staleTime: Infinity
  });

  let disabled = !values?.brand_name

  let lengths = inventory_values?.filter(el => el.attribute === "length");
  let materials = inventory_values?.filter(el => el.attribute === "material");
  let colors = inventory_values?.filter(el => el.attribute === "color");
  let lines = inventory_values?.filter(el => el.attribute === "line");

  return (
    <>
    <Grid item size={{xs: 12}}>
     <Field formFieldType="select" name="length" label="Length" disabled={disabled} options={getOptions(lengths)} />
    </Grid>
    <Grid item size={{xs: 12, lg: 4}}>
      <InputLabel>Select Colors</InputLabel>
      <AutoCompleteSoloMulti
        name="colors" 
        fieldName="value"
        serverOptions={colors} 
        disabled={disabled} 
      />
    </Grid>
    <Grid item size={{xs: 12, lg: 4}}>
      <InputLabel>Select Materials</InputLabel>
      <AutoCompleteSoloMulti
        name="types" 
        fieldName="value"
        serverOptions={materials} 
        disabled={disabled} 
      />
    </Grid>
    <Grid item size={{xs: 12, lg: 4}}>
      <InputLabel>Select Lines</InputLabel>
      <AutoCompleteSoloMulti
        name="lines" 
        fieldName="value"
        serverOptions={lines} 
        disabled={disabled} 
      />
    </Grid>
    <Grid item size={{xs: 12, lg: 4}}>
     <Field name="cost" label="Cost" type="number" disabled={disabled} />
    </Grid>
    <Grid item size={{xs: 12, lg: 4}}>
     <Field name="price" label="Price" type="number" disabled={disabled} />
    </Grid>
    </>
  )

};

export default PriceInfo